document.addEventListener("DOMContentLoaded", function () {
  const upsellButtons = document.querySelectorAll(".add-upsell-to-cart");

  upsellButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add item to cart");
          }
          return response.json();
        })
        .then((data) => {
          alert(`${data.title} has been added to your cart!`);
          location.reload(); // Optional: Reload to reflect updated cart
        })
        .catch((error) => {
          console.error("Error adding upsell item:", error);
          alert("An error occurred. Please try again.");
        });
    });
  });
});
